import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
  /* eslint-disable-next-line @angular-eslint/directive-selector */
  selector: 'a[UIKitLink]',
})
export class LinkDirective {
  @HostBinding('attr.disabled')
  get attributes() {
    return this.disabled;
  }
  // @ts-expect-error
  @Input() disabled: boolean;

  constructor() {}
}
